import {TranslationKey} from '@enums'
import {Stack, Typography} from '@mui/material'

import React from 'react'

import {ResponsiveContainer, BarChart, XAxis, YAxis, Bar, Tooltip} from 'recharts'

import {ComposedComponents, UIKit} from '@components'

import {useDashboardModel} from './dashboard-model'
import {StatsItemWrapper, StatsWrapper} from './style'

/**
 * Dashboard page with navigation cards and activity overview
 * Used as home page
 */
export function DashboardPage() {
  const {
    navigationCardItems,
    chartData,
    domain,
    bars,
    showStatsSection,
    tableColumns,
    tableRows,
    isDownLg,
    noStatsData,
    t,
  } = useDashboardModel()

  return (
    <Stack gap={5}>
      <ComposedComponents.NavigationCards items={navigationCardItems} itemsInRow={isDownLg ? 1 : 3} />
      {showStatsSection && (
        <StatsWrapper>
          <StatsItemWrapper>
            <UIKit.BackgroundCard title={t(TranslationKey['Contract statistics'])} height={300}>
              {noStatsData ? (
                <Typography>{t(TranslationKey['No statistics data for last seven days'])}</Typography>
              ) : (
                <ResponsiveContainer width="100%" height={'100%'}>
                  <BarChart
                    data={chartData}
                    barCategoryGap={5}
                    barGap={2.5}
                    margin={{
                      left: -35,
                      bottom: 55,
                    }}
                  >
                    <XAxis
                      fontSize={'1rem'}
                      dataKey="name"
                      tickFormatter={value => {
                        return String(value).substring(0, 6)
                      }}
                    />
                    <YAxis
                      fontSize={'1rem'}
                      domain={domain}
                      tickFormatter={value => (Number.isInteger(value) ? value : '')}
                    />
                    <Tooltip contentStyle={{textAlign: 'right'}} />
                    {bars.map((item, index) => (
                      <Bar key={`bar-${index}-${item.dataKey}`} {...item} />
                    ))}
                  </BarChart>
                </ResponsiveContainer>
              )}
            </UIKit.BackgroundCard>
          </StatsItemWrapper>
          <StatsItemWrapper>
            <UIKit.BackgroundCard height={300}>
              <UIKit.Table
                hidePagination
                hideSearch
                hideToolbar
                rows={tableRows}
                columns={tableColumns}
                title={t(TranslationKey['Latest activity'])}
              />
            </UIKit.BackgroundCard>
          </StatsItemWrapper>
        </StatsWrapper>
      )}
    </Stack>
  )
}
